import http from 'utils/http';

/** Global PosHub application catalog (read-only in Nibble admin; toggled via Django admin). */
export const getOrganizationPosHubApplications = (organizationId) => http
  .get(`v1/organizations/${organizationId}/integrations/poshub/applications/`)
  .then((res) => res.data?.data ?? res.data);

export const syncOrganizationPosHubApplications = (organizationId) => http
  .post(`v1/organizations/${organizationId}/integrations/poshub/applications/`)
  .then((res) => res.data?.data ?? res.data);

export const getPosHubStatus = (restaurantId) => http
  .get(`v1/restaurants/${restaurantId}/integrations/poshub/`)
  .then((res) => res.data?.data ?? res.data);

export const getPosHubCatalogCategories = (restaurantId, params = {}) => http
  .get(`v1/restaurants/${restaurantId}/integrations/poshub/catalog/categories/`, { params })
  .then((res) => res.data);

/**
 * Load the full catalog product list for menu builders.
 * Prefer ``all=1`` so the API aggregates PosHub-safe pages (large single-page
 * limits like 500 trigger PosHub HTTP 500 ``Unknown error``).
 */
export const getPosHubCatalogProducts = (restaurantId, params = {}) => http
  .get(`v1/restaurants/${restaurantId}/integrations/poshub/catalog/products/`, { params })
  .then((res) => res.data);

export const getAllPosHubCatalogCategories = (restaurantId) => getPosHubCatalogCategories(restaurantId, { all: 1 });

export const getAllPosHubCatalogProducts = (restaurantId) => getPosHubCatalogProducts(restaurantId, { all: 1 });

export const getPosHubCatalogModifiers = (restaurantId, params = {}) => http
  .get(`v1/restaurants/${restaurantId}/integrations/poshub/catalog/modifiers/`, { params })
  .then((res) => res.data);

export const getPosHubCatalogModifierGroups = (restaurantId, params = {}) => http
  .get(`v1/restaurants/${restaurantId}/integrations/poshub/catalog/modifier-groups/`, { params })
  .then((res) => res.data);

export const getPosHubMenus = (restaurantId) => http
  .get(`v1/restaurants/${restaurantId}/integrations/poshub/menus/`)
  .then((res) => res.data);

export const createPosHubMenu = (restaurantId, payload) => http
  .post(`v1/restaurants/${restaurantId}/integrations/poshub/menus/`, payload)
  .then((res) => res.data);

export const getPosHubMenu = (restaurantId, menuId) => http
  .get(`v1/restaurants/${restaurantId}/integrations/poshub/menus/${menuId}/`)
  .then((res) => res.data);

export const patchPosHubMenu = (restaurantId, menuId, payload) => http
  .patch(`v1/restaurants/${restaurantId}/integrations/poshub/menus/${menuId}/`, payload)
  .then((res) => res.data);

export const deletePosHubMenu = (restaurantId, menuId) => http
  .delete(`v1/restaurants/${restaurantId}/integrations/poshub/menus/${menuId}/`);

export const getPosHubMenuCategories = (restaurantId, menuId) => http
  .get(`v1/restaurants/${restaurantId}/integrations/poshub/menus/${menuId}/categories/`)
  .then((res) => res.data);

export const getPosHubMenuItems = (restaurantId, menuId) => http
  .get(`v1/restaurants/${restaurantId}/integrations/poshub/menus/${menuId}/items/`)
  .then((res) => res.data);

export const createPosHubMenuCategory = (restaurantId, menuId, payload) => http
  .post(`v1/restaurants/${restaurantId}/integrations/poshub/menus/${menuId}/categories/`, payload)
  .then((res) => res.data);

export const deletePosHubMenuCategory = (restaurantId, menuId, categoryId) => http
  .delete(`v1/restaurants/${restaurantId}/integrations/poshub/menus/${menuId}/categories/${categoryId}/`);

export const createPosHubMenuItem = (restaurantId, menuId, payload) => http
  .post(`v1/restaurants/${restaurantId}/integrations/poshub/menus/${menuId}/items/`, payload)
  .then((res) => res.data);

export const deletePosHubMenuItem = (restaurantId, menuId, itemId) => http
  .delete(`v1/restaurants/${restaurantId}/integrations/poshub/menus/${menuId}/items/${itemId}/`);

export const patchPosHubMenuItem = (restaurantId, menuId, itemId, payload) => http
  .patch(`v1/restaurants/${restaurantId}/integrations/poshub/menus/${menuId}/items/${itemId}/`, payload)
  .then((res) => res.data);

export const getPosHubMenuModifierGroups = (restaurantId, menuId) => http
  .get(`v1/restaurants/${restaurantId}/integrations/poshub/menus/${menuId}/modifier-groups/`)
  .then((res) => res.data);

export const getPosHubApps = (restaurantId) => http
  .get(`v1/restaurants/${restaurantId}/integrations/poshub/apps/`)
  .then((res) => res.data);

export const deletePosHubApp = (restaurantId, applicationId) => http
  .delete(`v1/restaurants/${restaurantId}/integrations/poshub/apps/${applicationId}/`);

/** Queues restaurant-level menu/catalog sync with Pos (same as merchant PosHub box). */
export const syncPosHubMenus = (restaurantId) => http
  .post(`v1/restaurants/${restaurantId}/integrations/poshub/sync-menus/`)
  .then((res) => res.data);

/** Per-connection catalog pull (PosHub reseller API), same as PosHub Apps "Sync catalog". */
export const posHubConnectionPull = (restaurantId, connectionId) => http
  .post(`v1/restaurants/${restaurantId}/integrations/poshub/connections/${connectionId}/pull/`, {})
  .then((res) => res.data);

export const getPosHubLocationSettings = (restaurantId) => http
  .get(`v1/restaurants/${restaurantId}/integrations/poshub/settings/`)
  .then((res) => res.data);

export const patchPosHubLocationSettings = (restaurantId, payload) => http
  .patch(`v1/restaurants/${restaurantId}/integrations/poshub/settings/`, payload)
  .then((res) => res.data);
